import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const LeafSolid = createSvgIcon(
  () => (
    <path d="M17 6.00007C12.0875 6.00007 7.93125 9.21882 6.51875 13.6563C8.61875 12.5938 10.9875 12.0001 13.5 12.0001H19C19.55 12.0001 20 12.4501 20 13.0001C20 13.5501 19.55 14.0001 19 14.0001H18H13.5C12.4625 14.0001 11.4563 14.1188 10.4875 14.3376C8.86875 14.7063 7.3625 15.3626 6.025 16.2563C2.39375 18.6751 0 22.8063 0 27.5001V28.5001C0 29.3313 0.66875 30.0001 1.5 30.0001C2.33125 30.0001 3 29.3313 3 28.5001V27.5001C3 24.4563 4.29375 21.7188 6.3625 19.8001C7.6 24.5188 11.8938 28.0001 17 28.0001H17.0625C25.3188 27.9563 32 19.8188 32 9.78757C32 7.12507 31.5312 4.59382 30.6812 2.31257C30.5187 1.88132 29.8875 1.90007 29.6688 2.30632C28.4938 4.50632 26.1688 6.00007 23.5 6.00007H17Z" />
  ),
  '0 0 32 32'
);
